// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + "products" + "." + "8e4496f6" + ".chunk.js";
};